import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const BooksContext = createContext({
  books: [],
  categories: [],
  loading: true,
  getBook: () => undefined,
  featuredBook: undefined,
  refresh: () => {},
});

export function BooksProvider({ children }) {
  const [books, setBooks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [b, c] = await Promise.all([
        axios.get(`${API}/api/books`),
        axios.get(`${API}/api/categories`),
      ]);
      setBooks(b.data || []);
      setCategories(c.data || []);
    } catch (e) {
      console.error("Failed to load books/categories:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const getBook = useCallback((slug) => books.find((b) => b.slug === slug), [books]);
  const featuredBook = books.find((b) => b.featured);

  return (
    <BooksContext.Provider value={{ books, categories, loading, getBook, featuredBook, refresh }}>
      {children}
    </BooksContext.Provider>
  );
}

export const useBooks = () => useContext(BooksContext);
